// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__36bAE","actions":"GroupTable_actions__2lpMY","deleteModalFooter":"GroupTable_deleteModalFooter__33cFJ"};